import type { PricingPlan } from "@/lib/plans";

export const scriptarioPricingPlans: PricingPlan[] = [
  {
    id: "free",
    name: "Free",
    price: "0",
    period: "",
    description: "For trying your first transcripts",
    features: ["15 transcription minutes", "Recordings up to 12 hours", "AI assistant and AI reports", "Export to files", "Speakers and timestamps"],
    buttonText: "Start free",
    isFree: true,
    isPopular: false,
    generationLimit: 5,
    messageLimit: 30,
    maxResolution: "512x512",
    transcriptionMinutes: 15,
    costPerMinute: "Unavailable",
  },
  {
    id: "basic",
    name: "Essential",
    price: "$10",
    yearlyPrice: "$60",
    period: "/ month",
    description: "for regular tasks",
    features: ["500 transcription minutes", "Recordings up to 12 hours", "AI assistant and AI reports", "Export to files", "Speakers and timestamps"],
    buttonText: "Start free",
    isFree: false,
    isPopular: false,
    generationLimit: 50,
    messageLimit: -1,
    maxResolution: "1024x1024",
    transcriptionMinutes: 500,
    costPerMinute: "",
  },
  {
    id: "standard",
    name: "Professional",
    price: "$17",
    yearlyPrice: "$102",
    period: "/ month",
    description: "for most tasks",
    features: ["1000 transcription minutes", "Recordings up to 12 hours", "AI assistant and AI reports", "Export to files", "Speakers and timestamps"],
    buttonText: "Start free",
    isFree: false,
    isPopular: true,
    generationLimit: 100,
    messageLimit: -1,
    maxResolution: "2048x2048",
    transcriptionMinutes: 1000,
    costPerMinute: "",
  },
  {
    id: "expert",
    name: "Premium",
    price: "$42",
    yearlyPrice: "$252",
    period: "/ month",
    description: "for high volumes",
    features: ["5000 transcription minutes", "Recordings up to 12 hours", "AI assistant and AI reports", "Export to files", "Speakers and timestamps"],
    buttonText: "Start free",
    isFree: false,
    isPopular: false,
    generationLimit: 250,
    messageLimit: -1,
    maxResolution: "2048x2048",
    transcriptionMinutes: 5000,
    costPerMinute: "",
  },
];

export const pricingPlans = scriptarioPricingPlans;
